import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "BreadcrumbsList" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!

  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.breadcrumbs, (item, index) => {
      return (_openBlock(), _createBlock(_component_Breadcrumb, {
        key: index,
        breadcrumb: item
      }, null, 8 /* PROPS */, ["breadcrumb"]))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}